import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
const links = [{
  to: '/',
  label: 'Home'
}, {
  to: '/how-it-works',
  label: 'How it works'
}, {
  to: '/getting-started',
  label: 'Getting started'
}, {
  to: '/why',
  label: 'Why Viridia'
}, {
  to: '/pricing',
  label: 'Pricing'
}, {
  to: '/contact',
  label: 'Contact'
}];
export function Nav() {
  const [open, setOpen] = useState(false);
  return <header className="sticky top-0 z-50 border-b border-[#1a1a1a] bg-[#0a0a0a]/85 backdrop-blur" data-id="element-336" data-mp="1fxuru8p8duch">
      <div className="mx-auto flex w-full max-w-6xl items-center justify-between px-6 py-4" data-id="element-337" data-mp="1kwfk9ly8r9qd">
        <Link to="/" className="flex items-center gap-2.5" onClick={() => setOpen(false)} data-id="element-338" data-mp="1prutu1p7ujgz">
          <img src="https://cdn.magicpatterns.com/uploads/dBgonnHgNocdZqWCx2rT29/VA-Logo_(1).png" alt="Viridia Analytics logo" className="h-8 w-8 object-contain" data-id="element-339" data-mp="1uqo7pv8f0cho" />
          <span className="text-sm font-semibold tracking-tight text-white" data-id="element-340" data-mp="23mx6r8shd93a">
            Viridia Analytics
          </span>
        </Link>

        <nav aria-label="Main" className="hidden items-center gap-8 md:flex" data-id="element-341" data-mp="1u43lmgntv5hd">
          {links.map(l => <NavLink key={l.to} to={l.to} end={l.to === '/'} className={({
          isActive
        }) => `text-sm transition-colors ${isActive ? 'text-white' : 'text-neutral-400 hover:text-white'}`} data-id="element-342" data-mp="1p6bj6spk40yx">
              {l.label}
            </NavLink>)}
        </nav>

        <div className="hidden md:block" data-id="element-343" data-mp="2832zct9sxzyr">
          <Link to="/contact" className="rounded-full bg-emerald-500 px-5 py-2.5 text-sm font-semibold text-[#0a0a0a] transition-colors hover:bg-emerald-400" data-id="element-344" data-mp="2821lyi5bd1dv">
            Book a 15-min call
          </Link>
        </div>

        <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-label={open ? 'Close menu' : 'Open menu'} className="rounded-md p-2 text-neutral-300 md:hidden" data-id="element-345" data-mp="2vsnwcg2sixr1">
          {open ? <XIcon className="h-5 w-5" data-id="element-346" data-mp="xzl6lhelmvro" /> : <MenuIcon className="h-5 w-5" data-id="element-347" data-mp="k7588twn7lx3" />}
        </button>
      </div>

      {open && <nav aria-label="Mobile" className="border-t border-[#1a1a1a] px-6 pb-6 pt-4 md:hidden" data-id="element-348" data-mp="p4wyljhn2zz6">
          <ul className="flex flex-col gap-4" data-id="element-349" data-mp="a7o44gx1hg38">
            {links.map(l => <li key={l.to} data-id="element-350" data-mp="f792ap4dxkew">
                <NavLink to={l.to} end={l.to === '/'} onClick={() => setOpen(false)} className={({
            isActive
          }) => `text-base ${isActive ? 'text-white' : 'text-neutral-300'}`} data-id="element-351" data-mp="f7ituh52vzmp">
                  {l.label}
                </NavLink>
              </li>)}
            <li data-id="element-352" data-mp="20l54nuwa4tfl">
              <Link to="/contact" onClick={() => setOpen(false)} className="mt-2 inline-block rounded-full bg-emerald-500 px-5 py-2.5 text-sm font-semibold text-[#0a0a0a]" data-id="element-353" data-mp="20jkbo9pm5iju">
                Book a 15-min call
              </Link>
            </li>
          </ul>
        </nav>}
    </header>;
}